import * as React from 'react'
import { observer } from 'mobx-react'
import { debounce, last } from 'lodash'
import { IHeaderParams } from 'ag-grid-community'

import Field from 'stores/field/Field'
import Script from 'stores/script/Script'

import createError from 'utils/createError'

import styles from './tableCellHeaderWithSearch.scss'

interface IProps extends IHeaderParams {
  field: Field
  script: Script
  onSearch: () => void
}

class TableCellHeaderWithSearch extends React.Component<IProps> {
  private handleSearchDebounced: () => Promise<void>

  constructor(props: IProps) {
    super(props)

    this.handleSearchDebounced = debounce(this.handleSearch, 500, {
      leading: false,
      trailing: true,
    })
  }

  handleChangeSearch = (e: React.FormEvent<HTMLInputElement>) => {
    const { field, script } = this.props

    const allWheres = Object.values(script.where.values)
    const where = allWheres.find(w => last(w.fieldIds) === field.id)

    if (!where) {
      throw createError(
        'TableCellHeaderWithSearch.handleChangeSearch',
        'Unable to find script `where` to update',
        {
          field: field.serialize(),
          script: script.serialize(),
          where: script.where.values,
        }
      )
    }

    where.update({ enabled: true, value: e.currentTarget.value })

    this.handleSearchDebounced()
  }

  handleSearch = async () => {
    this.props.onSearch()
  }

  render() {
    const { script, field } = this.props
    const where = Object.values(script.where.values).find(
      w => last(w.fieldIds) === field.id
    )

    return (
      <div data-cy="header-field-search" className={styles.container}>
        <div className={styles.title}>{field.name}</div>
        {where &&
        (last(where.fields)?.isScalar || last(where.fields)?.isEnum) ? (
          <input
            className={styles.input}
            type="text"
            placeholder={`search ${field.name}...`}
            value={where.value || ''}
            onChange={this.handleChangeSearch}
          />
        ) : (
          <div className={styles.inputPlaceholder} />
        )}
      </div>
    )
  }
}

export default observer(TableCellHeaderWithSearch)
